import ToolTip from 'patient-ping-remedy/packages/tool-tip';
import Icon, {ICONS} from 'patient-ping-remedy/packages/icon';
import {MessageThreadSummary} from '@/api/dto/message';
import {ItemWrapper, ItemContent} from '@/components/pages/messages/details/MessageThreadDetails.styles';

type Props = {
  messageThreadSummary?: MessageThreadSummary;
  concise?: boolean;
}

export default function MessageThreadMembers({ messageThreadSummary, concise }: Props) {
  if (!messageThreadSummary || (!concise && messageThreadSummary.users.length === 1)) {
    return null;
  }

  const users = messageThreadSummary.users
    .map((user) => `${user.first_name} ${user.last_name} ${user.deleted ? '(Deleted)' : ''}`)
    .join(', ');

  return (
    <ItemWrapper>
      <ToolTip text={users} position="bottom" type="dark">
        <ItemContent concise={concise}>
          <Icon iconClass={ICONS['user-friends']} iconSize={concise ? '1x' : 'lg'} />
          <span>{messageThreadSummary?.users.length} {!concise && 'members'}</span>
        </ItemContent>
      </ToolTip>
    </ItemWrapper>
  );
}
